import ResourceApi from '../ResourceApi';

const SkillResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/skills', params)).data,
  get: async (id, params = {}) => (await ResourceApi.get(`/resource/skills/${id}`, params)).data,
  post: async (params = {}) => (await ResourceApi.post('/resource/skills', params)).data,
  getTypes: async (params = {}) => (await ResourceApi.get('/resource/skills/types', params)).data,
};

export default SkillResource;
